import React from 'react';
import Icon from '../AppIcon';
import { getPlatformMessageStyle } from '../../lib/platformMessagesUtils';

const PlatformMessageBanner = ({ messages = [] }) => {
  if (!messages?.length) return null;

  return (
    <div className="platform-message-banners w-full" role="status" aria-live="polite">
      {messages.map((msg) => {
        const style = getPlatformMessageStyle(msg.messageType);
        return (
          <div
            key={msg.id}
            className={`px-4 py-3 sm:py-3.5 ${style.container}`}
          >
            <div className="mx-auto flex max-w-5xl flex-col items-center justify-center gap-2 text-center sm:flex-row sm:gap-3">
              <Icon
                name={style.icon}
                size={20}
                className={`shrink-0 opacity-95 ${style.iconClass || ''}`}
              />
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center justify-center gap-2">
                  <span className="font-semibold text-sm sm:text-base">{msg.title}</span>
                  {style.badge ? (
                    <span className={style.badgeClass || 'text-[10px] uppercase tracking-wide opacity-75 font-medium'}>
                      {style.badge}
                    </span>
                  ) : null}
                </div>
                {msg.body ? (
                  <p className="mt-1 text-sm opacity-95 whitespace-pre-wrap leading-snug">{msg.body}</p>
                ) : null}
                {msg.linkUrl ? (
                  <a
                    href={msg.linkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-1 mt-2 text-sm font-medium underline underline-offset-2 hover:opacity-80"
                  >
                    {msg.linkLabel || 'En savoir plus'}
                    <Icon name="ExternalLink" size={14} />
                  </a>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PlatformMessageBanner;
